import LabelClass from '@/model/LabelClass';
import {
  getLabels,
  delLabel,
} from '@/api/label';
import { AccountModule } from '@/store/modules/account';
import moment from 'moment';

type ILabelClass = ILabel.IModel.ILabelClass;
type IGetLabel = ILabel.IRequest.IGetLabel;
type ILabelInfo = ILabel.IResponse.ILabelInfo;



export default class LabelListClass implements ILabel.IModel.ILabelListClass {
  private $requestParams: IGetLabel = {};
  private $data: ILabelClass[] = [];
  private $labelForCreate: ILabelClass | null = null;
  get data() {
    return this.$data;
  }
  get labelForCreate() {
    return this.$labelForCreate;
  }
  public requestLabels(params?: IGetLabel): Promise<string> {
    return new Promise((reslove, reject) => {
      this.initRequestParams();
      const newParams = Object.assign({}, params);
      this.updateRequestParams(newParams);
      getLabels(this.$requestParams).then((res) => {
        this.updateLabelData(res.data);
        if (res.data.length > 0) {
          reslove(res.message);
        } else {
          reject('暂无数据');
        }
      }).catch((error) => {
        reject(error.message);
      });
    });
  }
  public requestDeleteLabel(labelId: string): Promise<string> {
    return new Promise((reslove, reject) => {
      delLabel(labelId).then((res) => {
        this.deleteLabel(labelId);
        reslove(res.message);
      }).catch((err) => {
        reject(err.message);
      });
    });
  }
  public updateLabelData(labels: ILabelInfo[]) {
    this.$data = labels.map((label) => new LabelClass(label));
  }
  public addLabels(labels: ILabelInfo[]) {
    const labelInstances = labels.map((label) => new LabelClass(label));
    this.$data.push(...labelInstances);
  }
  public deleteLabel(labelId: string) {
    const findIndex = this.$data.findIndex((label) => label.id === labelId);
    if (findIndex >= 0) {
      this.$data.splice(findIndex, 1);
    }
  }
  public createLabel() {
    const newLabel = new LabelClass();
    this.$labelForCreate = newLabel;
  }
  public unshiftLabel(label: ILabelClass) {
    label.createdName = AccountModule.name;
    label.createdOn = moment().toJSON(),
    this.$data.unshift(label);
  }

  private initRequestParams() {
    this.$requestParams = {};
  }
  private updateRequestParams(params?: IGetLabel) {
    Object.assign(this.$requestParams, params);
  }
}
